var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderInProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26.9039,
    rx: 7.5,
    fill: "#FFE6E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1336_20435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 19.9835C6.22467 19.6015 6.45371 19.221 6.67044 18.8369C6.71263 18.757 6.72835 18.666 6.71538 18.5768C6.61753 17.9971 6.48126 17.4224 6.4124 16.8398C6.33049 16.1534 6.75017 15.669 7.45036 15.593C7.69462 15.5672 7.74029 15.4332 7.74029 15.229C7.73666 14.2458 7.73014 13.2627 7.74029 12.2796C7.74899 11.5881 8.24767 11.0284 8.94858 10.8908C9.59006 10.7647 10.2924 11.118 10.5432 11.7342C10.6324 11.9764 10.6738 12.2333 10.665 12.4909C10.6447 13.5658 10.6911 14.6342 10.9433 15.6862C10.9636 15.7707 10.9904 15.8546 11.0158 15.9463L12.9931 15.0907C12.6307 13.7034 12.9989 12.5053 13.9354 11.4247L14.5153 12.0588C13.8854 12.8263 13.5498 13.7134 13.8209 14.7725C14.4464 14.5683 15.0531 14.3591 15.6714 14.1706C17.5226 13.6045 19.4006 13.1624 21.3403 13.0363C22.271 12.9761 23.2024 12.9789 24.091 13.3372C24.2512 13.4024 24.3041 13.3415 24.2853 13.1781C24.1729 12.1807 24.4107 11.7694 25.3646 11.3373C27.4975 10.3699 29.6316 9.40465 31.767 8.44157C32.2961 8.20152 32.8049 8.2266 33.229 8.62072C33.6639 9.02487 33.8951 9.53435 33.724 10.1449C33.6081 10.5469 33.3261 10.8077 32.947 10.9854C30.9479 11.9409 28.9513 12.9023 26.957 13.8696C26.8026 13.9413 26.6475 14.0165 26.4975 14.0989C26.2899 14.2182 26.0561 14.2859 25.8163 14.2963C25.5764 14.3067 25.3376 14.2593 25.1203 14.1584C25.071 14.1369 25.021 14.1176 24.971 14.0989C24.9659 14.0989 24.9572 14.1054 24.9326 14.1176C25.005 14.3949 25.0935 14.6736 25.1536 14.9588C25.5885 17.0226 25.1217 18.9229 23.9903 20.6635C22.2558 23.327 19.7232 24.8526 16.634 25.4975C14.3913 25.9676 12.1893 25.7999 10.0887 24.8426C8.14837 23.9605 6.74147 22.5674 6.03984 20.5367C6.02906 20.5115 6.0157 20.4875 5.99997 20.465V19.9835ZM11.3072 16.7589C11.3087 16.7975 11.3138 16.8359 11.3224 16.8735C11.9675 18.4242 13.083 19.4382 14.761 19.8022C14.8582 19.8194 14.9584 19.8105 15.0509 19.7764C16.2527 19.3407 17.4479 18.8857 18.6548 18.4658C19.2839 18.2508 19.6993 17.8158 20.0262 17.2777C20.1851 17.0288 20.3182 16.7647 20.4234 16.4894C20.5444 16.1352 20.6398 15.7729 20.709 15.4053C20.8423 14.7331 21.3961 14.2709 22.0651 14.2989C22.7341 14.3268 23.2524 14.8427 23.3082 15.5235C23.3118 15.5694 23.322 15.6152 23.3292 15.6604L23.4075 15.6926C23.625 15.3823 23.8721 15.085 24.0599 14.756C24.2048 14.4995 24.1323 14.3168 23.8598 14.1828C23.6763 14.0904 23.4813 14.022 23.2799 13.9793C22.4471 13.8023 21.6056 13.8524 20.7698 13.9442C18.5693 14.1849 16.4513 14.7661 14.3732 15.502C14.3046 15.5301 14.2376 15.5619 14.1724 15.5973L14.5747 16.1763L13.91 16.7252C13.7042 16.4386 13.5143 16.1691 13.3128 15.8854L11.3072 16.7589ZM13.2483 20.2959C12.7329 19.891 12.1958 19.5492 11.7588 19.1092C10.5968 17.9369 10.1076 16.4457 9.91406 14.8571C9.81693 14.0531 9.82853 13.2362 9.80388 12.4243C9.79663 12.1979 9.76184 11.9944 9.57121 11.851C9.48747 11.7813 9.38491 11.7374 9.27619 11.7246C9.16747 11.7119 9.05735 11.7309 8.95945 11.7794C8.71229 11.894 8.60211 12.0961 8.60211 12.3612C8.60211 13.3265 8.60211 14.2917 8.60211 15.2569C8.60211 15.9441 8.23462 16.3547 7.53806 16.4393C7.34743 16.4622 7.25683 16.5539 7.2677 16.7352C7.32641 17.7499 7.56415 18.7123 8.15054 19.565C8.58544 20.1992 9.18198 20.6305 9.96262 20.7237C10.3816 20.763 10.8041 20.7469 11.2188 20.6757C11.911 20.5739 12.5959 20.4213 13.2483 20.2959ZM21.1286 17.2354C21.3294 17.1157 21.5338 16.9631 21.7614 16.8635C22.3326 16.6148 22.392 16.1104 22.4341 15.5995C22.4375 15.494 22.4012 15.391 22.3323 15.3105C22.2634 15.2299 22.1667 15.1775 22.0609 15.1633C21.9552 15.1491 21.8479 15.1742 21.7597 15.2337C21.6716 15.2933 21.6089 15.383 21.5838 15.4855C21.4251 16.0645 21.2801 16.6478 21.1286 17.2354ZM25.1275 12.721C25.5624 12.5483 25.7386 12.5447 25.8698 12.7489C25.9356 12.8526 25.9632 12.9756 25.948 13.0972C25.927 13.214 25.8248 13.3157 25.7581 13.4232C26.1582 13.3852 26.4105 13.133 26.3989 12.7783C26.3927 12.6159 26.3252 12.4617 26.2097 12.3462C26.0941 12.2306 25.939 12.1621 25.7748 12.1542C25.4327 12.1398 25.1746 12.3663 25.1275 12.7224V12.721ZM8.06429 20.8899L8.07733 20.824L7.12853 19.6517C7.05881 19.7544 6.99446 19.8606 6.93573 19.9699C6.83208 20.1848 6.81613 20.4163 7.05677 20.5288C7.37715 20.6785 7.72724 20.7738 8.06429 20.8921V20.8899Z",
    fill: "url(#paint0_linear_1336_20435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7863 6.28613L15.4097 6.87444C14.8378 7.54157 14.3225 8.22447 14.2355 9.13596H13.3758C13.4447 7.97797 14.0535 7.10805 14.7863 6.28613Z",
    fill: "url(#paint1_linear_1336_20435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9423 4C13.171 3.99998 13.3905 4.089 13.5533 4.24779C13.7161 4.40658 13.8091 4.62236 13.8121 4.84843C13.8144 5.01897 13.7654 5.18633 13.6712 5.32924C13.5771 5.47215 13.442 5.58415 13.2833 5.65099C13.1246 5.71783 12.9493 5.73651 12.7799 5.70463C12.6104 5.67276 12.4543 5.59178 12.3315 5.47199C12.2087 5.3522 12.1247 5.19902 12.0902 5.03191C12.0557 4.8648 12.0722 4.69132 12.1377 4.53353C12.2032 4.37573 12.3146 4.24076 12.4579 4.14575C12.6012 4.05075 12.7698 4.00002 12.9423 4Z",
    fill: "url(#paint2_linear_1336_20435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7737 7.86921C10.7722 8.03975 10.7195 8.20601 10.6222 8.34684C10.5249 8.48768 10.3874 8.59672 10.2272 8.66012C10.0671 8.72352 9.89149 8.7384 9.72275 8.70288C9.55402 8.66736 9.39979 8.58303 9.27966 8.46063C9.15953 8.33823 9.07893 8.18327 9.04811 8.01547C9.01729 7.84766 9.03764 7.67459 9.10658 7.51824C9.17551 7.3619 9.28991 7.22936 9.43524 7.13746C9.58057 7.04556 9.75026 6.99847 9.92273 7.00215C10.151 7.00814 10.3679 7.10222 10.5269 7.26426C10.6859 7.4263 10.7745 7.64344 10.7737 7.86921Z",
    fill: "url(#paint3_linear_1336_20435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88698 9.15918H7.72198V9.98539H6.88698V9.15918Z",
    fill: "url(#paint4_linear_1336_20435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6638 9.58887H12.4944V10.4215H11.6638V9.58887Z",
    fill: "url(#paint5_linear_1336_20435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2238 14.2824C11.2172 14.2463 11.2126 14.21 11.21 14.1734C11.21 13.9427 11.21 13.712 11.21 13.4604H12.0581V14.2824H11.2238Z",
    fill: "url(#paint6_linear_1336_20435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3072 16.7594L13.3077 15.8844C13.5092 16.1711 13.6991 16.434 13.905 16.7243L14.5697 16.1754L14.1674 15.5964C14.2325 15.561 14.2995 15.5292 14.3682 15.5011C16.4462 14.7651 18.5642 14.184 20.7648 13.9432C21.6005 13.8515 22.442 13.7999 23.2749 13.9783C23.4763 14.021 23.6712 14.0894 23.8547 14.1818C24.1244 14.3173 24.2012 14.5 24.0548 14.7551C23.8671 15.084 23.6199 15.3814 23.4024 15.6917L23.3242 15.6594C23.3169 15.6143 23.3068 15.5684 23.3031 15.5226C23.2473 14.8418 22.7233 14.3266 22.0601 14.2979C21.3968 14.2693 20.8373 14.7322 20.7039 15.4043C20.6367 15.7723 20.5432 16.1351 20.4241 16.4899C20.3189 16.7652 20.1858 17.0293 20.0269 17.2782C19.7 17.8163 19.2847 18.2477 18.6555 18.4662C17.4487 18.8862 16.2534 19.3412 15.0517 19.7769C14.9591 19.811 14.859 19.8199 14.7617 19.8027C13.0838 19.4386 11.9682 18.4247 11.3231 16.874C11.3143 16.8364 11.3089 16.798 11.3072 16.7594ZM14.6646 18.1553V17.3204H13.8347V18.1553H14.6646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2483 20.2956C12.596 20.421 11.9081 20.5736 11.2152 20.6754C10.8 20.747 10.3771 20.7633 9.95758 20.7241C9.18056 20.6309 8.5862 20.1996 8.14913 19.5654C7.56274 18.7127 7.325 17.7503 7.26629 16.7356C7.25541 16.5543 7.34602 16.4626 7.53665 16.4397C8.23321 16.3551 8.59925 15.9445 8.6007 15.2573C8.6007 14.2921 8.6007 13.3269 8.6007 12.3616C8.6007 12.0965 8.71087 11.8944 8.95804 11.7798C9.05594 11.7313 9.16605 11.7123 9.27477 11.725C9.3835 11.7378 9.48606 11.7817 9.5698 11.8514C9.76043 11.9948 9.79522 12.1961 9.80247 12.4247C9.82711 13.2366 9.81552 14.0535 9.91264 14.8575C10.104 16.4461 10.5933 17.9388 11.7581 19.1096C12.1988 19.5496 12.7359 19.8907 13.2483 20.2956ZM11.0086 19.9523C10.5012 19.5869 10.0562 19.1999 9.89235 18.603H9.02255C9.17766 19.5489 9.7771 20.1429 10.5302 20.6603L11.0086 19.9523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1286 17.2351C21.2801 16.6475 21.4251 16.0642 21.5838 15.4853C21.6089 15.3827 21.6716 15.293 21.7597 15.2335C21.8478 15.174 21.9551 15.1489 22.0609 15.163C22.1667 15.1772 22.2633 15.2297 22.3323 15.3102C22.4012 15.3908 22.4374 15.4937 22.434 15.5992C22.392 16.1101 22.3325 16.6146 21.7614 16.8632C21.5338 16.9628 21.3294 17.1133 21.1286 17.2351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1275 12.7219C25.1746 12.3636 25.4327 12.1393 25.7748 12.1529C25.9389 12.1609 26.0941 12.2294 26.2096 12.345C26.3252 12.4605 26.3927 12.6147 26.3989 12.7771C26.4083 13.1354 26.1582 13.3862 25.7581 13.422C25.8248 13.3145 25.927 13.2127 25.948 13.0959C25.9632 12.9744 25.9356 12.8514 25.8697 12.7477C25.7385 12.5456 25.5617 12.5492 25.1275 12.7219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06419 20.8918C7.72714 20.7735 7.3785 20.6768 7.05667 20.5285C6.81603 20.416 6.83198 20.1831 6.93563 19.9695C6.99436 19.8603 7.05871 19.7541 7.12843 19.6514L8.07724 20.8258L8.06419 20.8918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6647 18.1551H13.8348V17.3203H14.6647V18.1551Z",
    fill: "url(#paint7_linear_1336_20435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0114 19.9523L10.5337 20.6603C9.78061 20.143 9.18118 19.5489 9.02606 18.603H9.89586C10.0589 19.1999 10.5018 19.5869 11.0114 19.9523Z",
    fill: "url(#paint8_linear_1336_20435)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1336_20435",
    x: 5.24997,
    y: 4,
    width: 29.2807,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.239216 0 0 0 0 0.682353 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1336_20435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1336_20435",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1336_20435",
    x1: 7.73626,
    y1: 5.35959,
    x2: 23.7574,
    y2: 17.0304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF000F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB000E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1336_20435",
    x1: 14.3928,
    y1: 6.28613,
    x2: 14.3928,
    y2: 9.13596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1336_20435",
    x1: 12.9424,
    y1: 4,
    x2: 12.9424,
    y2: 5.71978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1336_20435",
    x1: 9.9039,
    y1: 7.00195,
    x2: 9.9039,
    y2: 8.72174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1336_20435",
    x1: 7.30448,
    y1: 9.15918,
    x2: 7.30448,
    y2: 9.98539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1336_20435",
    x1: 12.0791,
    y1: 9.58887,
    x2: 12.0791,
    y2: 10.4215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1336_20435",
    x1: 11.634,
    y1: 13.4604,
    x2: 11.634,
    y2: 14.2824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1336_20435",
    x1: 14.2497,
    y1: 17.3203,
    x2: 14.2497,
    y2: 18.1551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1336_20435",
    x1: 10.0187,
    y1: 18.603,
    x2: 10.0187,
    y2: 20.6603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920009"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderInProgress);
export default __webpack_public_path__ + "static/media/order-in-progress.6c057f793360a6120988c63cddb9144c.svg";
export { ForwardRef as ReactComponent };